import { date } from 'io-ts-types';

export const DateType = date;
